module.exports = __webpack_public_path__ + "static/img/物业-1.52d65676.png";